/*=========================================================================================
  File Name: moduleSpaceState.js
  Description: Space Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ActiveSpaceInfo: {
      title:'AClass',
      url:'/test',
      id:0
  },
  ActiveDashBoardLevel: 0,
  workspaces: [],
  workspaceMembers: [],
  inviteList:[],
  checkboxClassState:3,
  checkboxAloneState:false,
  serviceWorkspaces:null,
  shareClass:[],
}
